import React, { useState } from "react";
import PropTypes from "prop-types";
import { Font } from "../../Fonts/Font";
import "./Category.scss";
import { MENU_DATA } from "../menuData";
import { useDispatch, useSelector } from "react-redux";
import { ROUTES } from "../../../../data";
import { userActions } from "../../../../redux/action";
import { Link } from "react-router-dom";

export const CategoryMenu = ({ menu, onHover, ...props }) => {
  const dispatch = useDispatch();
  const subMenuData = useSelector((el) => el?.productMeta?.data?.categories);
  const handleClick = (slug) => {
    if (!slug) return;
    dispatch(userActions.getCategory(slug));
    dispatch(userActions.getAllProducts());
    dispatch(userActions.getProductData());
  };

  // Limit display to max 12 categories
  const displayMenu = (menu || []).slice(0, 12);

  const [activeColor, setActiveColor] = useState(
    Array(displayMenu.length).fill("#292929")
  );
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const changeAtiveColor = (idx) => {
    let newColor = Array(displayMenu.length).fill("#292929");
    newColor[idx] = "#EE7200";
    setActiveColor(newColor);
  };

  // Get subcategories for a given parent category
  const getSubcategories = (parentId) => {
    return (subMenuData || []).filter((el) => el.parent === parentId);
  };

  return (
    <div className="es-custom-category" style={{ backgroundColor: "white" }}>
      {displayMenu.map((data, i) => {
        const children = getSubcategories(data.id);
        const hasChildren = children.length > 0;
        return (
          <div
            className={`category-item${hasChildren ? " has-children" : ""}`}
            onMouseOver={() => {
              changeAtiveColor(i);
              setHoveredIndex(i);
              onHover((subMenuData || []).filter((el) => el.parent === data.id));
            }}
            onMouseOut={() => {
              setHoveredIndex(null);
            }}
            key={i}
          >
            <div className="category-item-label">
              <Font
                label={data.name}
                clickable={true}
                color={activeColor[i]}
                size="16"
                weight="400"
                link={ROUTES.CATEGORY + "/" + (data.slug || data.id || "")}
                onClick={() => handleClick(data?.slug || data?.id || "")}
              />
              {hasChildren && <span className="chevron-arrow">&#8250;</span>}
            </div>
            {hasChildren && hoveredIndex === i && (
              <div className="category-submenu">
                {children.map((child, j) => (
                  <div key={j} className="category-submenu-item">
                    <Font
                      label={child.name}
                      clickable={true}
                      color="#292929"
                      size="14"
                      weight="400"
                      link={
                        ROUTES.CATEGORY +
                        "/" +
                        (data.slug || data.id || "") +
                        "/" +
                        (child.slug || child.id || "")
                      }
                      onClick={() => handleClick(child?.slug || child?.id || "")}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
      {(menu || []).length > 12 && (
        <Link to="/search" className="see-all-link">
          See All Categories
        </Link>
      )}
    </div>
  );
};

CategoryMenu.propTypes = {
  menu: PropTypes.array.isRequired,
  onHover: PropTypes.func.isRequired,
};

CategoryMenu.defaultProps = {
  menu: MENU_DATA,
};
